import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'DictTag',
  props: {
    dictList: {
      default: () => []
    },
    dicValue: {
      default: () => 0
    },
    colorType: {
      default: () => 0
    }
  },
  setup(__props) {
    const colorList = ref([['pink', 'purple', 'orange', 'cyan', 'green', 'blue', 'red'], ['red', 'green'], ['blue', 'orange', 'green', 'grey', 'cyan', 'green', 'blue', 'red']]);
    const props = __props;
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dictList, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [Number(item.dictValue) === props.dicValue ? (_openBlock(), _createBlock(_component_a_tag, {
          key: index,
          index: index,
          color: colorList.value[props.colorType][props.dicValue % colorList.value[props.colorType].length]
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.dictLabel + ' '), 1)]),
          _: 2
        }, 1032, ["index", "color"])) : _createCommentVNode("", true)], 64);
      }), 256))]);
    };
  }
});